import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";

import { editNotificationSegment, saveNotificationSegment } from "../../../redux/moduloNotificaciones/segmentoNotificacion/actions";
import Multiselect from "../../../components/MultiselectFormik";
import EmployeeSearch from "./EmployeeSearch";


const returnData2 = (value) => {
  var _list = [];
  value.map((item) => {
    _list = [..._list, { value: item.id, label: item.nombre }];
  });
  return _list;
};

const SegmentModal = (props) => {
  const [validated, setValidated] = useState(false);
  const dispatch = useDispatch();
  const [showModalEmployees, setShowModalEmployees] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeListSelected, setEmployeeListSelected] = useState([])


  //Redux
  const empresas = useSelector((store) => store.orgs.orgs);
  const empresasLoading = useSelector((store) => store.orgs.loading);

  const {
    saveLoading,
    formError,
  } = useSelector((store) => store.notificationSegment);


  // Esquema de validación con Yup
  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    empresas: Yup.array().notRequired(""),
  });


  //useEffects
  useEffect(() => {
    if (props.edit) {
      setEmployeeList([]);
      setEmployeeListSelected([]);
      // Si es edición, cargar los empleados seleccionados
      if (props.editItem.list_empleados && props.editItem.list_empleados.length > 0) {
        setEmployeeListSelected(props.editItem.empleado);
        setEmployeeList(props.editItem.list_empleados);
      }
    } else {
      setEmployeeList([]);
      setEmployeeListSelected([]);
    }

  }, [props])



  // Funciones
  const onSubmit = async (req) => {
    let data = { nombre: req.nombre.trim() }
    if (employeeListSelected.length === 0 && req.empresas.length === 0) {
      toastr.info("Debe seleccionar al menos un colaborador o una empresa")
      return;
    }

    //lista de empleados seleccionados
    if (employeeListSelected.length > 0)
      data.empleado = employeeListSelected;

    //lista de empresas seleccionadas
    var dataOrgT = [];
    req.empresas.map((item) => {
      dataOrgT = [...dataOrgT, item.value];
    });


    data.empresas = dataOrgT;

    if (!props.edit) {
      dispatch(
        saveNotificationSegment(data, props.setShowFormModal)
      );
    } else {
      dispatch(
        editNotificationSegment(data, props.editItem.id, props.index, props.setShowFormModal)
      );
    }
    onClose();
  };

  const onClose = () => {
    props.setShowFormModal(false);
    setValidated(false);
    setEmployeeList([]);
    setEmployeeListSelected([]);
  }


  return (
    <>
      {/* Modal con formik */}
      <Modal
        show={props.showFormModal}
        onHide={onClose}
        onShow={() => setValidated(false)}
        size="lg"
      >
        <Formik
          validationSchema={schema}
          onSubmit={(e) => {
            onSubmit(e);
          }}
          initialValues={{
            nombre: props.edit ? props.editItem.nombre : "",
            empresas:
              props.edit && props.editItem.list_empresas
                ? returnData2(props.editItem.list_empresas)
                : []
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {
                    props.edit
                      ? "Editar segmento"
                      : "Crear segmento"
                  }
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {formError && typeof formError !== "object" ? (
                  <Alert variant="danger" className="mt-4 mb-2">
                    {formError}
                  </Alert>
                ) : null}
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Nombre del segmento:
                    </Form.Label>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="Nombre del segmento"
                      onBlur={handleBlur("nombre")}
                      onChange={handleChange}
                      isInvalid={touched.nombre && !!errors.nombre}
                      isValid={touched.nombre && !errors.nombre}
                    ></Form.Control>
                    {touched.nombre && errors.nombre && (
                      <div>
                        <small className="text-danger px-2">
                          {errors.nombre}
                        </small>
                      </div>
                    )}
                    {formError &&
                      typeof formError === "object" &&
                      formError.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Colaboradores
                    </Form.Label>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={11}>
                        <div className="d-flex flex-wrap bg-light p-2 rounded">
                          {employeeList.length < 1 ? (
                            <Alert variant="info" className="mt-2 mb-1 w-100">
                              <i className="material-icons">info</i> Aún no ha seleccionado colaboradores.
                            </Alert>) : (
                            employeeList.map((item) => (
                              <span className="mr-1 mb-1 bg-secondary text-white p-1 rounded">
                                {item.codigo} / {item.nombre.toUpperCase()}
                                <Button
                                  size="sm"
                                  variant="link"
                                  className="ml-1 text-white p-0"
                                  onClick={() => {
                                    setEmployeeList(
                                      employeeList.filter(
                                        (emp) => emp.id !== item.id
                                      )
                                    );
                                    setEmployeeListSelected(
                                      employeeListSelected.filter(
                                        (emp) => emp !== item.id
                                      )
                                    );
                                  }}
                                >
                                  <i className="material-icons">close</i>
                                </Button>
                              </span>
                            )
                            )
                          )}
                        </div>
                      </Col>
                      <Col
                        sm={1}
                        className="d-flex flex-wrap align-items-center"
                      >
                        <Button
                          variant="light"
                          size="sm"
                          className="rounded-circle "
                          onClick={() => setShowModalEmployees(true)}
                        >
                          <i className="material-icons">app_registration</i>
                        </Button>
                      </Col>

                    </Row>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} controlId="Empresas">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Form.Label column className="ml-2">
                        Empresas
                      </Form.Label>
                      <Col sm={empresasLoading ? "10" : "12"}>
                        <Multiselect
                          id="empresas"
                          name="empresas"
                          options={returnData2(empresas)}
                          value={values.empresas}
                          onChange={(selected) => {
                            setFieldValue(
                              "empresas",
                              selected.length > 0 ? selected : []
                            );
                          }}
                          isValid={touched.empresas && !errors.empresas}
                          isInvalid={touched.empresas && errors.empresas}
                          isDisabled={
                            empresasLoading ||
                            returnData2(empresas).length === 0
                          }
                          onBlur={() => handleBlur("empresas")}
                        />
                        {touched.empresas && errors.empresas && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.empresas}
                            </small>
                          </div>
                        )}
                      </Col>
                      {empresasLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={onClose}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      {/* fin de con formik */}

      {/*  Modal colaboradores*/}
      <EmployeeSearch
        setEmployeesList={setEmployeeList}
        showModal={showModalEmployees}
        setShowModal={setShowModalEmployees}
        setEmployeeListSelected={setEmployeeListSelected}
      />

      {/* modal de colaboradores */}
    </>
  );
};

export default SegmentModal;
